import axios from 'axios';

const BASE_URL = "https://script.google.com/macros/s/AKfycbyUoaZd-ZrxBNauudN2aqkGWxXNnuAaaspG13LtPcn2hbR_quEykJmkr2WrwUGW4lI3/exec";

export const fetchDataFromApi = async (columns, sheet) => {
  try {
    const response = await axios.get(BASE_URL, { params: { sheet, columns: columns.join(",") } });
    return Array.isArray(response.data.data) ? response.data.data : [];
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const fetchAvailableYears = async () => {
  try {
    const response = await axios.get(BASE_URL, { params: { action: "getYears" } });
    return Array.isArray(response.data.data) ? response.data.data : [];
  } catch (error) {
    console.error("Error fetching available years:", error);
    return [];
  }
};
